import { CasClient } from '@central-products/cas-client';
import { getDeviceInfo } from '@sitebase/device-detector';
import { PassiveLoginNativeStrategy } from './PassiveLoginNativeStrategy';
import { PassiveLoginPollingStrategy } from './PassiveLoginPollingStrategy';
import {
  SessionPassiveLoginListenerStrategy,
  SessionPassiveLoginListenerConfig,
  SessionPassiveLoginListenerInterface,
  PassiveLoginStrategyInterface,
} from '../types';

export class SessionPassiveLoginListener implements SessionPassiveLoginListenerInterface {
  private readonly strategy?: PassiveLoginStrategyInterface;

  constructor(
    config: SessionPassiveLoginListenerConfig & {
      casClient: CasClient;
      onLoginCallback: () => void;
    }
  ) {
    switch (getDeviceInfo().isNative && config.strategy) {
      case SessionPassiveLoginListenerStrategy.NATIVE:
        this.strategy = new PassiveLoginNativeStrategy(config);
        break;
      case SessionPassiveLoginListenerStrategy.POLLING:
        this.strategy = new PassiveLoginPollingStrategy(config);
        break;
    }
  }

  public async init() {
    return this.strategy?.init();
  }

  public close() {
    return this.strategy?.close();
  }
}
